import { render } from "./VideoUploader.vue?vue&type=template&id=70a6ec5c&scoped=true"
import script from "./VideoUploader.vue?vue&type=script&lang=js"
export * from "./VideoUploader.vue?vue&type=script&lang=js"

import "./VideoUploader.vue?vue&type=style&index=0&id=70a6ec5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a6ec5c"]])

export default __exports__